export interface MagazzinoApiDescriptor {
	id:				string;
	codice:			string;
	indirizzo:		string;
	referente:		string;
	azienda:		number; // fk
	regioni:		number[]; // fk
}


export enum TipoMovimentazione {
	TIM_IMPRESA= "TIM_IMPRESA",
	MAGAZZINO_MAGAZZINO = "MAGAZZINO_MAGAZZINO",
	IMPRESA_INSTALLAZIONE = "IMPRESA_INSTALLAZIONE",
	ALLINEAMENTO_IMPRESA = "ALLINEAMENTO_IMPRESA",
	ALLINEAMENTO_TIM = "ALLINEAMENTO_TIM",
	IMPRESA_TIM = "IMPRESA_TIM",
	INSTALLAZIONE_RIENTRO = "INSTALLAZIONE_RIENTRO"
}

export enum StatoDiscrepanza {
	SEGNALATA = "SEGNALATA",
	NONCONFERMATA = "NONCONFERMATA",
	RISOLTA = "RISOLTA",
	CONFERMATO_ANNULLAMENTO = "CONFERMATO_ANNULLAMENTO"
}

export interface DiscrepanzaUpdateApiDescriptor {
	id:					string;
	stato: 				StatoDiscrepanza,
	rif_correttivo:		string;
}

export interface MovimentazioneApiDescriptor {
	id:				string;
	tipo:			string;
	pratica:		number;
	stato_pratica:	number;
	materiali:		{
		id:			string;
		qt:			number;
	}[];
	origine:		string;
	destinazione:	string;
	spedito:		string; // YYYY-MM-DD
	consegnato:		string; // YYYY-MM-DD
	correttivo_per:	string; // se la movimentazione è correttivo per altre movimentazioni, in questo caso discrepanza DEVE essere nullo
	discrepanza:	{
		id:			string;
		stato:		StatoDiscrepanza;
	},
	note:			string;
}

export interface ModelloDispositivoApiDescriptor {
	id: 				string;
	nmu:				string;
	marca:				string;
	descrizione:		string;
	listino: 			number;
	verifica_seriale:	boolean;
}

export interface MovimentazioneApiBuilder {
	id?:				string;
	tipo:				TipoMovimentazione|string;
	pratica:			number | null;
	origine:			string | null;
	destinazione:		string | null;
	data_richiesta:		string; // YYYY-mm-dd
	materiali:			{[key: string]: number};
	note?:				string;
}

export interface ScortaMaterialeApiDescriptor {
	rif_magazzino:		string;
	rif_azienda:		number;
	rif_modello:		string;
	balance:			number;

	// some human readable stuff for debug may be removed later
	cod_magazzino:		string;
	nmu:				string;
	ragione_sociale:	string;

}

export interface ScortaScuolaMaterialeApiDescriptor {
	rif_modello:		string;
	rif_pratica:		number;
	nmu:				string;
	cui:				string;
	balance:			number;
}

export interface ScuolaApiSummary {
	id:				number;
	codice_miur:	string;
	nome:			string;
	indirizzo:		string;
	comune:			string;
	regione:		string;
	provincia:		string;
	prov_sigla:		string;
}

export interface ScuolaPraticaApiDescriptor {
	pratica:			{
		id:				number;
		cui:			string;
		azienda:		number;
		scuola:			number;
		stato_ff2:		number
	};
	scuola: 			ScuolaApiSummary;
}

export interface DiscrepanzaDetailsApiDescriptor {
	id:					string;
	stato:				StatoDiscrepanza;
	correttivo:			string;
	segnalata:			string;  // YYYY-MM-DD
	aggiornata:			string; // YYYY-MM-DD
	movimentazione:		{
		id:					string;
		tipo:				string;
		pratica:			string;
		origine:			string;
		destinazione:		string;
		richiesta:			string; // YYYY-MM-DD
		spedizione:			string;  // YYYY-MM-DD
		consegna:			string;  // YYYY-MM-DD
	};
	materiali:				{
		id:					string;
		expected:			string;
		delta:				number; // negativo
	}[]
}

export interface ReportChiusuraMovimentazioniPratica {
	consegnate:				string[];
	rientri:				{
		materiali:			{[key: string]: number}
		movimentazione?:	string;
	}
}
